import { render, staticRenderFns } from "./AppDialogWithBtn.vue?vue&type=template&id=3b74ed4e&scoped=true"
import script from "./AppDialogWithBtn.vue?vue&type=script&lang=js"
export * from "./AppDialogWithBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b74ed4e",
  null
  
)

export default component.exports